export default __webpack_public_path__ + "static/media/video.406b87fc.mp4";